interface LayoutConfig {
  navigationEndpoint: string;
  headerEndpoint: string;
  footerEndpoint: string;
  useLangSwitch: boolean;
  useAuthentication: boolean;
}

export const mainNavigationConfig: LayoutConfig = {
  navigationEndpoint: '/api/content/main-navigation',
  headerEndpoint: '/api/content/header',
  footerEndpoint: '/api/content/footer',
  useLangSwitch: true,
  useAuthentication: false,
};

export const alumniNavigationConfig: LayoutConfig = {
  navigationEndpoint: '/api/content/alumni/alumni-navigation',
  headerEndpoint: '/api/content/alumni/alumni-header',
  footerEndpoint: '/api/content/alumni/alumni-footer',
  useLangSwitch: false,
  useAuthentication: true,
};

export function initLayoutConfig(config: LayoutConfig) {
  provide<LayoutConfig>('layout-config', config);
}

export function useLayoutConfig() {
  const layoutConfig = inject<LayoutConfig>('layout-config', mainNavigationConfig);

  return { layoutConfig };
}
